import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class AppVersionInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(map(event => {
            if (event instanceof HttpResponse) {
                // Local photo-gallery proxy (localhost) can return a different app-version
                // than production APIs. Ignoring it prevents an infinite reload loop.
                const url = event.url || req.url || '';
                if (url.indexOf('/api/v3/photo-galleries') !== -1) {
                    return event;
                }

                const appVersion = event.headers.get('app-version');
                if (appVersion) {
                    const preAppVersion = localStorage.getItem('appVersion');
                    if (!preAppVersion) {
                        localStorage.setItem('appVersion', appVersion);
                    } else {
                        if (preAppVersion !== appVersion) {
                            localStorage.setItem('appVersion', appVersion);
                            window.location.reload();
                        }
                    }
                }
            }
            return event;
        }));
    }
}
